<template>
    <analytics-stat-card
        :loading="loading"
        :error="Boolean(error)"
        :value="Boolean(error) ? undefined : dataComputed.number"
        minHeight="140px"
        :href="props.href"
    >
        <template v-slot:title>
            {{ dataComputed.title }}
        </template>
        <template v-slot:subtitle> All Time </template>

        <span>{{ dataComputed.label }}</span>

        <template v-slot:explainHeader>
            <template v-if="props.status === 'opt_in'"> Subscribers </template>
            <template v-else-if="props.status === 'opt_out'">
                <!-- to be defined? -->
            </template>
            <template v-else-if="props.status === 'unknown'"> Potential Subscribers </template>
            <template v-else> Contacts </template>
        </template>
        <template v-slot:explainContent>
            <p v-if="props.status === 'opt_in'">
                <strong>Total Subscribers</strong><br />
                Count of all Voxie contacts with a Marketing Subscription Status of Opt In. This represents all contacts
                eligible to be targeted by Marketing Campaigns.
            </p>
            <p v-else-if="props.status === 'opt_out'">
                <!-- to be defined? -->
            </p>
            <p v-else-if="props.status === 'unknown'">
                Quantity of Contacts that neither Opted in or out for Marketing Communications.
            </p>
            <p v-else>
                <strong>Total Contacts</strong><br />
                Count of all contacts in Voxie.
            </p>
            <router-button :to="{ name: 'contacts.list' }" size="sm" color="muted">
                Go to Contacts
                <font-awesome-icon widthAuto :icon="faArrowRight"></font-awesome-icon>
            </router-button>
        </template>
    </analytics-stat-card>
</template>
<script setup>
import AnalyticsStatCard from '../../partial/AnalyticsStatCard.vue';
import { vxFormatCount } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import RouterButton from '~/components/general/RouterButton.vue';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { analyticsClient } from '~/services';
import { computed, watch } from 'vue';
import { useVersionedRequest } from '~/composables/useVersionedRequest';

const props = defineProps({
    status: {
        type: String,
        default: undefined,
        validator: (type) => ['opt_in', 'opt_out', 'unknown'].includes(type),
    },
    orgUnitId: {
        type: Number,
    },
    groupId: {
        type: String,
    },
    type: {
        type: String,
        default: undefined,
        validator: (type) => ['affiliated', 'preferred'].includes(type),
    },
    href: {
        type: String,
    },
});

const titleFor = (status) => {
    switch (status) {
        case 'opt_in':
            return 'Total Subscribers';
        case 'opt_out':
            return 'Total Unsubscribers';
        case 'unknown':
            return 'Potential Subscribers';
        default:
            return 'Total Contacts';
    }
};

const { loading, response, error, fetchData } = useVersionedRequest();

const dataComputed = computed(() => {
    const number = (response.value?.data?.data || [])
        .filter((group) =>
            props.status ? group.subscription_status === props.status : group.subscription_status !== undefined
        )
        .reduce((acc, curr) => acc + (curr.value || 0), 0);

    return {
        number: number,
        label: vxFormatCount(number),
        title: titleFor(props.status),
    };
});

watch(
    [() => props.status, () => props.type, () => props.orgUnitId, () => props.groupId],
    () => {
        fetchData(
            analyticsClient.getMarketingSubscriptionsTotalByStatus(
                {
                    teamId: Spark.state.currentTeam.id,
                    orgUnitId: props.orgUnitId,
                    groupId: props.groupId,
                },
                props.type
            )
        ).catch((e) => {
            console.error(e);
        });
    },
    { immediate: true }
);
</script>
